module.exports = __webpack_public_path__ + "assets/img/4.0bcc966f.png";